import { GuideOrderThemeSizeConfig } from './types';

const medium: GuideOrderThemeSizeConfig = {
  guideOrder: {},
};

export default medium;
